module.exports = __webpack_public_path__ + "img/core-bg2-img1.b39aeed3.png";